/**
 * Ajustes de plural do app sobre o resolvedor do i18next:
 *  - em pt, o zero conta como plural ("0 documentos"), não como singular do CLDR;
 *  - pt e es têm a categoria `many` (milhões redondos) e os dicionários só declaram `_one` e `_other`:
 *    sem este ajuste a chave sai crua ("etapa.depois") para 1000000.
 */
export type ResolvedorPlural = { getSuffix: (codigo: string, n: number, opcoes?: unknown) => string };

export function ajustarPlural(resolvedor: ResolvedorPlural) {
  const original = resolvedor.getSuffix.bind(resolvedor);
  resolvedor.getSuffix = (codigo, n, opcoes) => {
    const sufixo = original(codigo, codigo.startsWith('pt') && n === 0 ? 2 : n, opcoes);
    return sufixo === '_many' || sufixo === '_few' || sufixo === '_two' || sufixo === '_zero' ? '_other' : sufixo;
  };
}
